<template>
  <div class="section-partners">
    <div class="container">
      <div class="section__header">
        <h3 class="section__title mb-5">Some of Our Partners</h3>
        <h3 class="section__subtitle">
          <p class="mb-5">
            We can accommodate Operators, Resellers and Platform Providers to
            grow our businesses together.
          </p>
        </h3>
      </div>
      <div class="partner-images">
        <div>
          <img
            class="partner-img"
            :src="getImagePath('apcopay')"
            alt="apcopay"
            title="apcopay"
            loading="lazy"
          />
        </div>
        <div>
          <img
            class="partner-img"
            :src="getImagePath('income-access')"
            alt="income-access"
            title="income-access"
            loading="lazy"
          />
        </div>
        <div>
          <img
            class="partner-img"
            :src="getImagePath('googlecloud')"
            alt="google-cloud"
            title="google-cloud"
            loading="lazy"
          />
        </div>
        <div>
          <img
            class="partner-img"
            :src="getImagePath('betradar')"
            alt="betradar"
            title="betradar"
            loading="lazy"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OurPartner",
  components: {},

  data() {
    return {
      publicPath:process.env.VUE_APP_PUBLIC_PATH ?? "/",
      lang: localStorage.getItem("language") ?? "en",
      loadingComplete: false,
    };
  },
  computed: {},
  mounted() {},
  created() {
    document.body.style.fontFamily = "Poppins, sans-serif";
  },
  methods: {
    getImagePath(partner) {
      return this.publicPath+`assets/img/logos/${partner}.png`;
    },
  },
};
</script>

<style scoped>
.section-partners {
  position: relative;
  box-shadow: 0 0 30px 0 rgba(48, 38, 57, 0.05);
  text-align: center;
  background-color: #09041f;
  color: #fff;
}

.container {
  padding: 100px 0;
}

.section__header {
  margin: 0 0 40px;
}

.section-partners .container .section__title {
  font-size: 40px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: 1px;
  text-align: center;
  color: #fff;
}

.section-partners .container .section__subtitle {
  font-size: 16px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.75;
  letter-spacing: normal;
  text-align: center;
  color: #a797b6;
}
.section__header:after {
  content: "";
  display: block;
  width: 150px;
  margin: 0 auto;
}
.section__header:after {
  border-bottom: 1px solid #fff;
}

.partner-images {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.partner-img {
  max-width: 200px;
  transition: 0.3s all;
  aspect-ratio: 4 / 3;
  -o-object-fit: contain;
  object-fit: contain;
  margin: 10px 15px;
  filter: contrast(0.4);
}

.partner-img:hover {
  transform: scale(1.1);
}

@media (max-width: 768px) {
  .container {
    padding: 50px 15px;
  }
  .partner-img {
    max-width: 130px;
    transition: 0.3s all;
    aspect-ratio: 4 / 3;
    -o-object-fit: contain;
    object-fit: contain;
    margin: 0px 5px;
  }

  .partner-images {
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
  }

  .section-partners .container .section__title {
    font-size: 30px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.25;
    letter-spacing: 1px;
    text-align: center;
    color: #fff;
  }
}
</style>
